export enum ExportTaskType {
  CUSTOMER_LIST = 'CUSTOMER_LIST',
  ORDER_LIST = 'ORDER_LIST',
  RESERVATION_LIST = 'RESERVATION_LIST',
}

export enum ExportTaskStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  EXPIRED = 'EXPIRED',
}

export interface ExportTaskResponse {
  id: number;
  storeId: number;
  exportType: ExportTaskType;
  status: ExportTaskStatus;
  fileName?: string;
  errorMessage?: string;
  createdAt: string;
  completedAt?: string;
  expiresAt?: string;
  totalRecords?: number;
  downloadUrl?: string;
}
